import React, { useEffect, useState } from "react";
import {
    FaArrowRight,
    FaChevronLeft,
    FaChevronRight,
    FaCheckCircle,
    FaCode,
    FaGlobeAfrica,
    FaLaptopCode,
    FaPlay,
    FaRocket,
    FaShieldAlt,
    FaBullhorn,
} from "react-icons/fa";

import api from "../api/api";
import "./HomeHeaderSave.css";

const HomeHeader = () => {
    const [slides, setSlides] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await api.get("/api/slides/");

                const data = response.data.results || response.data;

                setSlides(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Failed to load slides:", err);
                setError("Unable to load technology showcase");
            } finally {
                setLoading(false);
            }
        };

        fetchSlides();
    }, []);

    useEffect(() => {
        if (slides.length <= 1) return;

        const timer = setInterval(() => {
            setCurrentIndex(
                (previous) => (previous + 1) % slides.length
            );
        }, 10000);

        return () => clearInterval(timer);
    }, [slides]);

    useEffect(() => {
        setIsVisible(false);

        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, 120);

        return () => clearTimeout(timeout);
    }, [currentIndex]);

    const goToNext = () => {
        if (!slides.length) return;

        setCurrentIndex(
            (previous) => (previous + 1) % slides.length
        );
    };

    const goToPrevious = () => {
        if (!slides.length) return;

        setCurrentIndex(
            (previous) =>
                (previous - 1 + slides.length) % slides.length
        );
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    if (loading) {
        return (
            <section className="slider-loader">
                <div className="loader-content">
                    <div className="loader-logo">
                        <span>POLU</span>
                    </div>

                    <div className="spinner"></div>

                    <h3>POLU Integrated Technology</h3>

                    <p>
                        Preparing your digital experience...
                    </p>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="slider-loader error">
                <div className="loader-content">
                    <div className="error-icon">!</div>

                    <h3>Something went wrong</h3>

                    <p>{error}</p>

                    <button
                        className="retry-button"
                        onClick={() => window.location.reload()}
                    >
                        Try Again
                    </button>
                </div>
            </section>
        );
    }

    if (slides.length === 0) {
        return (
            <section className="slider-loader">
                <div className="loader-content">
                    <div className="loader-logo">
                        <span>POLU</span>
                    </div>

                    <h3>POLU Integrated Technology</h3>

                    <p>
                        Building smarter digital solutions for Africa.
                    </p>
                </div>
            </section>
        );
    }

    return (
        <header className="school-header">

            <div className="school-tech-grid"></div>

            <div className="school-slider-container">

                {slides.map((slide, index) => (
                    <div
                        key={slide.id || index}
                        className={`school-slide ${
                            currentIndex === index ? "active" : ""
                        }`}
                        style={{
                            backgroundImage: `
                                linear-gradient(
                                    110deg,
                                    rgba(3, 10, 22, 0.96) 0%,
                                    rgba(3, 18, 36, 0.84) 42%,
                                    rgba(3, 18, 36, 0.45) 70%,
                                    rgba(3, 10, 22, 0.72) 100%
                                ),
                                url("${slide.image}")
                            `,
                        }}
                    >

                        <div className="tech-glow tech-glow-one"></div>

                        <div className="tech-glow tech-glow-two"></div>

                        {currentIndex === index && (
                            <div
                                className={`school-text ${
                                    isVisible ? "animate" : ""
                                }`}
                            >

                                <div className="hero-brand">
                                    <span className="brand-polu">
                                        POLU
                                    </span>

                                    <span className="brand-integrated">
                                        {" "}
                                        INTEGRATED TECHNOLOGY
                                    </span>
                                </div>

                                <div className="hero-badge">
                                    <span className="badge-dot"></span>

                                    <span>
                                        TECHNOLOGY • INNOVATION •
                                        DIGITAL SOLUTIONS
                                    </span>
                                </div>

                                <h1>
                                    {slide.title}
                                </h1>

                                <div className="hero-divider">
                                    <span></span>
                                </div>

                                <p>
                                    {slide.description}
                                </p>

                                <div className="hero-actions">

                                    <a
                                        href="#services"
                                        className="hero-main-button"
                                    >
                                        Explore Our Solutions
                                        <FaArrowRight />
                                    </a>

                                    <button className="hero-play-button">
                                        <span>
                                            <FaPlay />
                                        </span>

                                        Discover POLU
                                    </button>

                                </div>

                                <div className="hero-check-list">

                                    <div>
                                        <FaCheckCircle />
                                        <span>
                                            Digital Transformation
                                        </span>
                                    </div>

                                    <div>
                                        <FaCheckCircle />
                                        <span>
                                            Smart Technology
                                        </span>
                                    </div>

                                    <div>
                                        <FaCheckCircle />
                                        <span>
                                            Built for Africa
                                        </span>
                                    </div>

                                </div>

                            </div>
                        )}

                    </div>
                ))}

                {slides.length > 1 && (
                    <div className="slider-navigation">

                        <button
                            className="slider-arrow"
                            onClick={goToPrevious}
                            aria-label="Previous slide"
                        >
                            <FaChevronLeft />
                        </button>

                        <button
                            className="slider-arrow"
                            onClick={goToNext}
                            aria-label="Next slide"
                        >
                            <FaChevronRight />
                        </button>

                    </div>
                )}

                <div className="slide-counter">

                    <span>
                        {String(currentIndex + 1).padStart(2, "0")}
                    </span>

                    <div className="counter-line"></div>

                    <span>
                        {String(slides.length).padStart(2, "0")}
                    </span>

                </div>

            </div>

            <aside className="school-right-panel">

                <div className="technology-panel-header">

                    <div className="panel-logo">
                        P
                    </div>

                    <div>
                        <span>POLU INTEGRATED</span>
                        <strong>TECHNOLOGY</strong>
                    </div>

                </div>

                <div className="announcement-box">

                    <div className="announcement-top">

                        <div className="announcement-icon">
                            <FaBullhorn />
                        </div>

                        <div>
                            <span>POLU UPDATE</span>
                            <h3>Technology News</h3>
                        </div>

                    </div>

                    <div className="announcement-content">

                        <h4>
                            Building Africa's Digital Future
                        </h4>

                        <p>
                            We design and develop modern digital
                            platforms that help organizations work
                            smarter, faster, and more efficiently.
                        </p>

                        <button className="announcement-button">
                            Learn More
                            <FaArrowRight />
                        </button>

                    </div>

                </div>

                <div className="school-info-cards">

                    <div className="school-card">

                        <div className="school-card-icon">
                            <FaLaptopCode />
                        </div>

                        <div>
                            <h3>Software Solutions</h3>

                            <p>
                                Modern web applications, business
                                platforms, and customized software
                                solutions.
                            </p>
                        </div>

                    </div>

                    <div className="school-card">

                        <div className="school-card-icon teacher">
                            <FaShieldAlt />
                        </div>

                        <div>
                            <h3>Secure Technology</h3>

                            <p>
                                Reliable, scalable, and secure
                                digital systems designed for modern
                                organizations.
                            </p>
                        </div>

                    </div>

                </div>

                <div className="technology-services">

                    <div className="service-mini">
                        <FaCode />
                        <span>Development</span>
                    </div>

                    <div className="service-mini">
                        <FaRocket />
                        <span>Innovation</span>
                    </div>

                    <div className="service-mini">
                        <FaGlobeAfrica />
                        <span>Africa First</span>
                    </div>

                </div>

                <div className="school-panel-message">

                    <div className="message-icon">
                        <FaRocket />
                    </div>

                    <div>
                        <strong>
                            Technology That Moves Business Forward
                        </strong>

                        <span>
                            Innovation • Reliability • Growth
                        </span>
                    </div>

                </div>

            </aside>

            {slides.length > 1 && (
                <div className="school-indicators">

                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`school-indicator ${
                                currentIndex === index
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        >
                            <span></span>
                        </button>
                    ))}

                </div>
            )}

            <div className="hero-bottom-label">

                <span>
                    <b>POLU</b> INTEGRATED TECHNOLOGY
                </span>

                <div className="bottom-label-line"></div>

                <small>
                    DIGITAL SOLUTIONS FOR A SMARTER FUTURE
                </small>

            </div>

        </header>
    );
};

export default HomeHeader;

